import axios from 'axios';

const baseUrl = process.env.REACT_APP_AWS_API_GATEWAY_URL;
const baseUrlExecuteFlow = process.env.REACT_APP_AWS_API_GATEWAY_URL_EXECUTE_FLOW;


// CONSUMO GENERICO DE LA API
export const callApi = (process, action, variables, accessToken, extraData = {}) => {
    return axios({
        method: 'POST',
        url: baseUrl,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        data: JSON.stringify({
            process,
            action,
            variables: JSON.stringify(variables),
            ...extraData, // para casos como findOne: 'true'
        }),
    });
};


// CONSUMO GENERICO DE LA API PARA FLOWS
export const callApiFlow = (variables, accessToken) => {
    return axios({
        method: 'POST',
        url: baseUrlExecuteFlow,
        headers: {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(variables),
    });
};
